import React, { useState } from 'react';
import { FaMobileAlt, FaBarcode, FaSimCard, FaMobile, FaExclamationTriangle } from 'react-icons/fa';
import axiosInstance from '../utils/axiosConfig';
import { Modal } from './common';
import './FormModal.css';

const MARCAS_SMARTPHONES = [
  'Xiaomi',
  'Samsung',
  'iPhone',
  'Tecno',
  'Infinix',
  'Honor',
  'Apple'
];

function AddSmartphoneModal({ isOpen, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    marca: '',
    modelo: '',
    serial: '',
    imei: '',
    imei2: '',
    estado: 'Disponible',
    activo_fijo: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axiosInstance.post('/api/smartphones', formData);
      onAdd(response.data.smartphone);
      onClose();
    } catch (error) {
      setError(error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen !== undefined ? isOpen : true} onClose={onClose} size="lg">
      <Modal.Header onClose={onClose}>Agregar Nuevo Smartphone</Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="add-smartphone-form">
          <div className="form-modal-section">
            <h3><FaMobileAlt /> Información del Smartphone</h3>
            <div className="form-modal-grid">
              <div className="form-modal-group">
                <label htmlFor="marca">
                  <FaMobileAlt className="input-icon" /> Marca
                </label>
                <select
                  id="marca"
                  name="marca"
                  value={formData.marca}
                  onChange={handleChange}
                  required
                >
                  <option value="">Seleccione una marca</option>
                  {MARCAS_SMARTPHONES.map(marca => (
                    <option key={marca} value={marca}>
                      {marca}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-modal-group">
                <label htmlFor="modelo">
                  <FaMobile className="input-icon" /> Modelo
                </label>
                <input
                  type="text"
                  id="modelo"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Redmi Note 12"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="serial">
                  <FaBarcode className="input-icon" /> Serial
                </label>
                <input
                  type="text"
                  id="serial"
                  name="serial"
                  value={formData.serial}
                  onChange={handleChange}
                  required
                  placeholder="Ej: ABC123XYZ"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="activo_fijo">
                  <FaBarcode className="input-icon" /> Activo Fijo
                </label>
                <input
                  type="text"
                  id="activo_fijo"
                  name="activo_fijo"
                  value={formData.activo_fijo}
                  onChange={handleChange}
                  placeholder="Ej: 1234"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="imei">
                  <FaSimCard className="input-icon" /> IMEI Principal
                </label>
                <input
                  type="text"
                  id="imei"
                  name="imei"
                  value={formData.imei}
                  onChange={handleChange}
                  required
                  placeholder="15 dígitos numéricos"
                  maxLength="15"
                  pattern="[0-9]{15}"
                  title="El IMEI debe contener 15 dígitos numéricos"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="imei2">
                  <FaSimCard className="input-icon" /> IMEI Secundario
                </label>
                <input
                  type="text"
                  id="imei2"
                  name="imei2"
                  value={formData.imei2}
                  onChange={handleChange}
                  placeholder="Opcional - 15 dígitos"
                  maxLength="15"
                  pattern="[0-9]{15}"
                  title="El IMEI debe contener 15 dígitos numéricos"
                />
              </div>
            </div>
          </div>

          {error && (
            <div className="form-modal-error">
              <FaExclamationTriangle />
              {error}
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onClose} className="btn btn-secondary">
          Cancelar
        </button>
        <button type="submit" form="add-smartphone-form" className="btn btn-primary" disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddSmartphoneModal; 